export default {
  search: '搜索',
  editFailed: '编辑失败',
  editSuccessfully: '编辑成功',
  location: '位置',
  ratio: '比例',

  rotation: '旋转',
  angle: '角度',
  addedFailures: '新增失败',
  addedSuccess: '新增成功',
  theDeletionWasSuccessful: '删除成功',
  panel: '面板',
  tips: '提示',
  color: '颜色',
  associativeMeasurementPoints: '关联测点',
  pleaseEnter: '请输入',
  measurementPoint: '测点',
  deviceName: '设备名称',
  deviceNumber: '设备位号',
  dynamicModels: '动态模型',
  whetherToConfirmTheDeletionOfTheCurrentDynamicDeviceEffect: '是否确认删除当前动态设备效果?',
  deviceCategoryAcquisitionFailed: '设备类别获取失败',
  creationTime: '创建时间',
  creatorName: '创建人',
  confirm: '确定',
  deviceCategory: '设备类别',
  modificationFailed: '修改失败',
  theModificationWasSuccessful: '修改成功',
  whethertoDeleteTheSelectedPanel: '是否删除选中面板',
  saveSuccessfully: '保存成功',
  cancel: '取消',
  reset: '重置',
  return: '返回',
  parentNode: '父节点',
  save: '保存',
  check: '查看',
  operate: '操作',
  propertyExpansion: '属性拓展',

  objectEncoding: '对象编码',
  description: '描述',
  serialNumber: '序号',
  measurementPointCoding: '测点编码',
  measurementPointName: '测点名称',
  import: '导入',
  pleaseFillInTheInitialValue: '请填写初始值',
  pleaseFillInTheHighReportRange: '请填写高高报范围',
  pleaseFillInTheHighAndHighReport: '请填写高高报',
  pleaseFillInTheScopeOfTheHighReport: '请填写高报范围',
  HColorLiquidOnly: '高报颜色（容器液位使用）',
  HHColorLiquidOnly: '高高报颜色（容器液位使用）',
  pleaseFillInTheMeasurementPointCode: '请填写测点编码',
  pleaseFillInTheHighReport: '请填写高报',
  highReporting: '高报',
  overstatementRange: '高报范围',
  overstatementRangeGasOnly: '高报范围(气体报警使用)',
  highReportRangeGasOnly: '高高报范围(气体报警使用)',
  highReportRange: '高高报范围',
  highAndHigh: '高高报',
  HColor: '高报颜色',
  HHColor: '高高报颜色',
  initialValue: '初始值',
  unit: '单位',
  export: '导出',
  deviceEncodingOrDeviceName: '设备编码或设备名称',
  measuringPointInfo: '测点编码或测点名称',
  delete: '删除',
  edit: '编辑',
  noDataYet: '暂无数据',
  searchForTheName: '搜索名称',
  new: '新增',
}
